import { GraphIcon } from './GraphIcon';

/**
 * author: Simran
 * id 76AC59FA-C58D-4A55-AE8F-A351AF2CD43A
 * name graph
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/graph.svg
 * tags
 */
export const DependencyIcon = GraphIcon;
export default DependencyIcon